import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { getKey } from "../../helpers/sessionKey";
import EditDeliveryCharge from "../EditDeliveryCharge";
import ComboboxInput from "../Reusable/ComboboxInput";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import DateRangePicker from "../Reusable/DateRangerPicker";
import Modal from "../Reusable/Modal";
import CreateRiderForm from "./CreateRiderForm";
import InvoiceDataTable from "../Reusable/InvoiceDataTable";

const CreateRiderInvoice = (props: any) => {
  const { handleCreate, isLoading, gridData } = props;
  const [searchParams, setSearchParms] = useSearchParams();
  const [openCreateInvoicePopup, setOpenCreateInvoicePopup] = useState(false);
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const [statusData, setStatusData] = useState();
  const [selectedOrder, setSelectedOrder] = useState("");
  const [orderActionMenu, setOrderActionMenu] = useState(false);
  const [data, setData] = useState();
  const [id, setId] = useState();
  const [chargevalue, setChargeValue] = useState();
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`invoice-${selectedOrder}`],
    navigateURL: "",
  });
  const handleCreateinvoice = async (values: any) => {
    const url = `${APIS.RIDER_INVOICE}report/`;
    let formData = {
      order_ids: values,
      rider: getValues("rider"),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setData(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    watch,
    getValues,
    clearErrors,
  } = useForm<any>();

  let defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <div className={tw`flex justify-center w-full`}>
            <input
              type="checkbox"
              checked={checkedAllItems}
              onChange={() => handleSelectAll(table)}
              className={tw`cursor-pointer`}
            />
          </div>
        );
      },
      cell: ({ row }: any) => (
        <div className={tw`flex justify-center w-full`}>
          <input
            type="checkbox"
            checked={isSelected(row?.original?.order?.id)}
            onChange={() => handleIndividualSelect(row?.original?.order?.id)}
            className={tw`cursor-pointer`}
          />
        </div>
      ),
    },
    {
      header: "WayBill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            {/* <p className={tw`text-xs text-primary`}>
              {row?.original?.pickup_branch?.warehouse?.name}
            </p> */}
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "order.sender.full_name",
      cell: NACell,
    },
    {
      header: "Receiver",
      accessorKey: "order.receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw``}>
              {row?.original?.order?.receiver?.full_name ?? "N/A"}{" "}
            </p>
            <p className={tw`whitespace-nowrap text-sm`}>
              {row?.original?.order?.receiver?.primary_contact ?? "N/A"}{" "}
            </p>
            <p className={tw`text-sm`}>
              {row?.original?.order?.receiver?.address ?? "N/A"}{" "}
            </p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            {/* <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p> */}
          </>
        );
      },
    },
    {
      header: "Finance",
      accessorKey: "order.deliver_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`whitespace-nowrap`}>
              COD: {row?.original?.order?.cod ?? 0.0}{" "}
            </p>
            <p className={tw`whitespace-nowrap`}>
              Collected: {row?.original?.order?.collected_cod ?? 0.0}
            </p>
            {/* <button
              className="whitespace-nowrap cursor-pointer"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setOpenDeliveryModal(!openDeliveryModal);
                setId(row?.original?.id);
                setChargeValue(row?.original?.deliver_charge);
              }}
            >
              D. Charge:{getValue()}
            </button> */}
          </>
        );
      },
    },
    {
      header: "Delivery Charge",
      accessorKey: "order.delivery_charge",
      cell: ({ row, getValue }: any) => {
        return <p>{getValue() ?? 0}</p>;
      },
    },
    // {
    //   header: "Piece",
    //   accessorKey: "piece",
    //   cell: ({ row, getValue }: any) => {
    //     return <p>{getValue() ?? 0}</p>;
    //   },
    // },
    {
      header: "Weight(kg)",
      accessorKey: "order.weight",
      cell: ({ row, getValue }: any) => {
        return <p>{getValue() ?? 0}</p>;
      },
    },
    {
      header: "Status",
      accessorKey: "order.delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.order?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.order?.rider?.name}
            </p>
          </>
        );
      },
    },
  ];

  const defaultCargoColumns = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: () => <p className={tw`w-full text-center`}>WAYBILL</p>,
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <button
            type="button"
            className={tw`cursor-pointer focus:outline-none`}
          >
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
            <p className={tw`whitespace-nowrap`}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>{" "}
          </button>
        );
      },
    },
    {
      header: "Forwarding No.",
      accessorKey: "forwarding_no",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Country",
      accessorKey: "receiver.country",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "total_piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "charge_wt",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    // {
    //   header: "Remarks",
    //   accessorKey: "remark",
    //   cell: ({ row, getValue }: any) => (
    //     <button
    //       onClick={() => {
    //         setSelectedOrder(row?.original?.id);
    //         setOpenReviewModal(true);
    //       }}
    //     >
    //       {getValue()} Remarks
    //     </button>
    //   ),
    // },
    {
      header: "Created By",
      accessorKey: "created_by",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Hub",
      accessorKey: "hub.name",
      cell: NACell,
    },
    {
      header: "P. Type",
      accessorKey: "reference_type.name",
      cell: NACell,
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <AccessControl
    //       children={
    //         <div className={tw` w-full items-center`}>
    //           <div>
    //             <TableActionButton editPath={`edit/${getValue()}`} />
    //           </div>
    //         </div>
    //       }
    //       allowedPermissions={["can_editupdate_consignment"]}
    //     />
    //   ),
    // },
  ];
  const handleActionMenu = () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder) {
      toast.error("Please select at least one order first");
      setOrderActionMenu(false);

      return;
    } else {
      setOpenCreateInvoicePopup(!openCreateInvoicePopup);
      handleCreateinvoice(selectedOrder);
    }
  };
  const handleRowClick = (row) => {
    console.log();
  };
  const filterParams = watch();
  const [user, setUser] = useState<any>("");

  useEffect(() => {
    {
      gridData?.map((item: any) => {
        if (item?.slug === "rider-to-be-invoiced") {
          setStatusData(item?.status?.map((item: any) => item.id).join(","));
        }
      });
    }
  }, [gridData]);

  const clientType = getKey("client-type");

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={() => handleActionMenu()}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <div className={tw` mb-4  grid grid-cols-2 gap-2`}>
          <ComboboxInput
            url={APIS.RIDER}
            queryKey={"rider"}
            register={register("manifest__driver", {
              required: "Rider Name is required",
            })}
            errors={errors?.vendor}
            name={"manifest__driver"}
            label={"Select Rider"}
            props={{ is_active: true }}
            setValue={setValue}
            placeholder={"Select Rider"}
            getValues={getValues}
            clearErrors={clearErrors}
            setUser={setUser}
          />
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
        </div>
      </FormLayout>
      <Modal
        isOpen={openCreateInvoicePopup}
        setIsOpen={setOpenCreateInvoicePopup}
        title={"Are You Sure You Want to Create Statement?"}
        children={
          <>
            <CreateRiderForm
              handleCreate={handleCreate}
              isLoading={isLoading}
              getValues={getValues}
              handleSubmit={handleSubmit}
              data={data}
              loading={isPostLoading}
              setError={setError}
              user={user}
            />
          </>
        }
      />
      <Modal
        title={"Update Delivery Charge"}
        isOpen={openDeliveryModal}
        setIsOpen={setOpenDeliveryModal}
        children={
          <>
            <div className={tw`w-[400px]`}>
              <EditDeliveryCharge
                id={id}
                openDeliveryModal={openDeliveryModal}
                setOpenDeliveryModal={setOpenDeliveryModal}
                chargevalue={chargevalue}
              />
            </div>
          </>
        }
      />
      {user ? (
        <InvoiceDataTable
          url={APIS.RIDER_ORDERS}
          queryKey={"orders"}
          search={false}
          columns={
            clientType === "cargo" ? defaultCargoColumns : defaultColumns
          }
          tableName={"rider-orders"}
          isUpload={true}
          handleRowClick={handleRowClick}
          isDownload={true}
          params={{
            ...filterParams,
            rider_invoice_id__isnull: true,
            is_create_invoice: true,
            is_invoiced: false,
            // delivery_status__in: statusData,
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CreateRiderInvoice;
